import { useMediaQuery } from './use-media-query';

/**
 * True when the roleplay stage is phone- or small-tablet-sized and should use the
 * rail layout (steps/coach in a left column, transcript in a right one) instead of
 * the desktop layout, where those float over the classroom.
 *
 * Height matters as much as width here: a phone in landscape is wide enough for
 * the desktop overlays but only ~360px tall, so the HUD, coach bubble, step pill
 * and control cluster all end up stacked on each other over the students.
 *
 * This hook is the SINGLE source of truth for that switch — the compact styles in
 * StreamPage.scss hang off the `.main-content--compact` class the page sets from
 * it, deliberately not off their own media queries. Two independent breakpoints
 * are how the earlier version broke: the CSS switched at 600px and 769–860px, so a
 * 740px-wide phone in landscape got desktop styling with no rule covering it.
 */
export const COMPACT_STAGE_QUERY = '(max-width: 900px), (max-height: 560px)';

export const useCompactStage = (): boolean => useMediaQuery(COMPACT_STAGE_QUERY);
